<template>
  <div>
    <template v-if="!isLoading">
      <MultiSelectComponent
        id="studentCharacteristicSelector"
        v-model="currentArray"
        class="mb-2 my-1"
        :max-selected-options="1"
        :label="trans('subscription.classification_config.selectors.student_characteristic.select_student_characteristic')"
        :type="'student-characteristic'"
        track-by="name"
        @input="changeSelectedValues"
      />
      <div class="values-background m-2 mt-3">
        <div class="py-1 ps-3 mb-0 fw-bold title-background">
          {{ trans_choice('subscription.classification_config.selectors.student_characteristic.values',2) }}
        </div>
        <div class="p-2">
          <template v-for="(value, index) in selector.values">
            <div
              :key="index"
              class="d-flex align-items-center"
            >
              <RuleSmallButton
                v-if="index != 0"
                class="btn-danger p-2 small-button-width fw-bold mx-2"
                :title="'-'"
                @click.native="removeValue(index)"
              />
              <div
                v-else
                class="empty-space-instead-of-delete-button"
              />
              <input
                :value="value"
                class="flex-grow-1 form-control me-4 my-1"
                @change="updateValue(index,$event)"
              >
            </div>
          </template>
          <RuleSmallButton
            class="mx-5 mt-2 btn-primary p-2 small-button-width"
            :title="''"
            @click.native="addValue()"
          >
            <span class="fa fa-plus" />
          </RuleSmallButton>
        </div>
      </div>
    </template>
    <Loader
      v-else
      class="pb-3"
    />
  </div>
</template>

<script>
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import selectorMixin from '@/employees/components/Selector/utilities/mixins/selectorMixin'
import { SELECTOR_PROPERTY } from '@/constants'
import { mapState } from 'vuex'
export default {
  name: 'SelectorStudentCharacteristic',
  components: { MultiSelectComponent },
  mixins: [selectorMixin],
  props: {
    selectorReference: {
      required: true,
      type: String,
    },
    selector: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      selector_property: SELECTOR_PROPERTY,
      isLoading: false,
      currentArray: [],
    }
  },
  computed: {
    ...mapState({
      missingId (state) {
        if (!state.studentCharacteristics.studentCharacteristics.hasOwnProperty(this.selector.student_characteristic)) {
          return this.selector.student_characteristic
        }
        return null
      },
      studentCharacteristics (state) {
        if (!state.studentCharacteristics.studentCharacteristics.hasOwnProperty(this.selector.student_characteristic)) {
          return []
        }
        const result = state.studentCharacteristics.studentCharacteristics[this.selector.student_characteristic]
        return [{
          id: this.selector.student_characteristic,
          name: result.name,
        }]
      },
    }),
  },
  mounted () {
    //* This mechanism is build, because it is not clear when you can get all the relevant student characteristics
    //* can not currently be retrieved without rewriting a lot of back-end code
    this.isLoading = true
    if (this.selector.student_characteristic && this.missingId) {
      this.$store.dispatch('getStudentCharacteristics', {
        queryParams: {
          filter: {
            id: this.missingId,
          },
        },
      }).then(() => { this.currentArray = this.studentCharacteristics })
    }
    this.currentArray = this.studentCharacteristics
    this.isLoading = false
  },
  methods: {
    changeSelectedValues (newValue) {
      const newValueArray = newValue.map(row => row.id)
      if (this.selector.studentCharacteristics) {
        if (this.arraysNotEqual(this.selector.studentCharacteristics, newValue)) {
          this.setValue(newValueArray)
        }
      } else {
        this.setValue(newValueArray)
      }
    },
    setValue (newValueArray) {
      if (newValueArray.length > 0) {
        this.selectorPropertyValueAdd(this.selectorReference, this.selector_property.student_characteristic, newValueArray[0])
      } else {
        this.selectorPropertyValueAdd(this.selectorReference, this.selector_property.student_characteristic, undefined)
      }
    },
    arraysNotEqual (array1, array2) {
      return array1.sort().join(',') !== array2.sort().join(',')
    },
    addValue () {
      const shallowClone = this.selector.values
      shallowClone.push('')
      this.selectorPropertyValueAdd(this.selectorReference, this.selector_property.values, shallowClone)
    },
    updateValue (index, event) {
      const shallowClone = this.selector.values
      shallowClone[index] = event.target.value
      this.selectorPropertyValueAdd(this.selectorReference, this.selector_property.values, shallowClone)
    },
    removeValue (index) {
      const shallowClone = this.selector.values
      shallowClone.splice(index, 1)
      this.selectorPropertyValueAdd(this.selectorReference, this.selector_property.values, shallowClone)
    },
  },
}
</script>

<style lang="scss" scoped>
.title-background {
  background-color: rgba(0, 0, 0, 0.3);
}
.values-background {
  background-color: rgba(0, 0, 0, 0.07);
}
/deep/
.col-sm-2 {
  float: none;
}
/deep/
.col-sm-10 {
  float: none;
}
.focus-style {
  border-style: hidden;
  background: none;
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5);
  }
}
.form-control{
  width: auto !important;;
}
.empty-space-instead-of-delete-button{
  margin-left: 28px;
}
</style>
